import { BoneModal } from './BoneModal';

export function initPromoBannerModal()
{
	const elem = document.getElementById('gr-promo-banner');
	const delay = 7000; // delay in milliseconds

	if (!elem)
	{
		return;
	}

	const modal = new BoneModal(elem);
	if (!modal)
	{
		return;
	}

	// Check if session storage exists
	const sessionModalClosed = sessionStorage.getItem('session_modal_closed');
	if (sessionModalClosed)
	{
		return;
	}

	const timer = setTimeout(() =>
	{
		modal.open();
	}, delay);

	// click trap closes modal
	const clickTrap = modal.elem.querySelector('.promo-banner-modal__click-trap');
	if (clickTrap)
	{
		clickTrap.addEventListener('click', () =>
		{
			closeModal();
		});
	}

	// Close button closes modal
	const closeBtn = modal.elem.querySelector('.promo-banner-modal__close-btn');
	if (closeBtn)
	{
		closeBtn.addEventListener('click', () =>
		{
			closeModal();
		});
	}

	// Set session storage when modal is closed
	if (modal.elem)
	{
		const content = modal.elem.querySelector('.find-location-modal-content');
		if (content)
		{
			content.addEventListener('click', (e) =>
			{
				if (e.target.tagName.toUpperCase() === 'A')
				{
					closeModal();
				}
			});
		}
	}

	const closeModal = () =>
	{
		modal.close();
		sessionStorage.setItem('session_modal_closed', 'true');
	};
}



// WEBPACK FOOTER //
// ./scripts/modules/promo-banner.js